import { render, staticRenderFns } from "./NumCheck.vue?vue&type=template&id=a9f0bf52&scoped=true&"
import script from "./NumCheck.vue?vue&type=script&lang=js&"
export * from "./NumCheck.vue?vue&type=script&lang=js&"
import style0 from "./NumCheck.vue?vue&type=style&index=0&id=a9f0bf52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f0bf52",
  null
  
)

export default component.exports